import { render, staticRenderFns } from "./BatchSetStockModal.vue?vue&type=template&id=3f8bf605&scoped=true"
import script from "./BatchSetStockModal.vue?vue&type=script&lang=js"
export * from "./BatchSetStockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bf605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f8bf605')) {
      api.createRecord('3f8bf605', component.options)
    } else {
      api.reload('3f8bf605', component.options)
    }
    module.hot.accept("./BatchSetStockModal.vue?vue&type=template&id=3f8bf605&scoped=true", function () {
      api.rerender('3f8bf605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/material/modules/BatchSetStockModal.vue"
export default component.exports